import React from 'react'
import {Button} from 'react-bootstrap'

const LoadingButton = ({className, isLoading}) => (
    <Button bsStyle="primary"
            className={className || ''}
            type="submit"
            disabled={isLoading}>
        {isLoading ? 'Please wait...' : 'Login'}
    </Button>
)

export default LoadingButton



// WEBPACK FOOTER //
// ./src/components/ui/LoadingButton.js